import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface ExpLaboral{
  auth_key:string,
  data:[{
    id:number,
    id_user:number,
    empresa:string,
    cargo:string,
    fechaini:number,
    fechafin:number,
    actual:number
  }]
}
@Injectable({
  providedIn: 'root'
})
export class ExperiencialaboralService {

  constructor(private http: HttpClient) { }

  get(id,auth_key){
    var headers = new HttpHeaders();
    const options = {headers: headers,withCredintials: false };
    let postData = [];
    postData.push({'auth_key':auth_key,'id':id});
    return this.http.post<ExpLaboral>(environment.urlExpLaboral+'?opcion=1', JSON.stringify(postData));
    /********************** */
  }
  create(id,auth_key,data){
    var headers = new HttpHeaders();
    const options = {headers: headers,withCredintials: false };
    let postData = [];
    postData.push({'auth_key':auth_key,'id':id});
    postData.push({'data':data});
    return this.http.post<ExpLaboral>(environment.urlExpLaboral+'?opcion=2', JSON.stringify(postData));
    /********************** */
  }
  delete(id,auth_key,data){
    var headers = new HttpHeaders();
    const options = {headers: headers,withCredintials: false };
    let postData = [];
    postData.push({'auth_key':auth_key,'id':id});
    postData.push({'data':data});
    return this.http.post<ExpLaboral>(environment.urlExpLaboral+'?opcion=3', JSON.stringify(postData));
    /********************** */
  }
}
